<div class="app-container">

  <!-- ===== WELCOME STATE ===== -->
  <div class="welcome-view" *ngIf="messages.length === 1">
    <div class="welcome-content">

      <div class="welcome-icon"></div>

      <div class="welcome-header">
        <h1 class="welcome-greeting">
          {{ greeting }}<span *ngIf="userName">, {{ userName }}</span>
        </h1>
        <p class="welcome-app-name">Always on, always loyal, always solving</p>
      </div>

      <div class="search-card">
        <input
          type="text"
          [(ngModel)]="userInput"
          (keypress)="onKeyPress($event)"
          placeholder="e.g. List all members at RMIT Melbourne"
          [disabled]="isLoading" />
        <button
          class="search-btn"
          (click)="sendMessage()"
          [disabled]="!userInput.trim() || isLoading">
          Search
        </button>
      </div>

      <div class="welcome-chips">
        <button *ngFor="let example of exampleQueries"
                class="chip-btn"
                (click)="useExample(example)"
                [disabled]="isLoading">
          {{ example }}
        </button>
      </div>

    </div>
  </div>

  <!-- ===== CHAT STATE ===== -->
  <div class="chat-view" *ngIf="messages.length > 1">

    <div class="chat-header">
      <div class="chat-header-left">
        <div class="chat-icon"></div>
        <span class="chat-title">iMIS Staff Assistant</span>
      </div>
      <div class="chat-header-right">
        <button class="header-btn" (click)="exportCSV()" [disabled]="!hasResults()" title="Export results as CSV">
          📊 Export CSV
        </button>
        <button class="header-btn accent" (click)="resetChat()" title="Start a new conversation">
          + New Chat
        </button>
      </div>
    </div>

    <div class="messages" #messageContainer>
      <div *ngFor="let message of messages"
           class="message-wrapper"
           [class.user]="message.role === 'user'"
           [class.assistant]="message.role === 'assistant'">
        <div class="message" [class.has-grid]="message.html">
          <div class="message-header">
            <span class="role">{{ message.role === 'user' ? 'You' : 'Assistant' }}</span>
            <span class="timestamp">{{ message.timestamp | date:'shortTime' }}</span>
          </div>
          <div class="message-content" [innerHTML]="formatMessage(message.content)"></div>
          <div *ngIf="message.html" class="member-grid" [innerHTML]="message.html"></div>
        </div>
      </div>

      <div *ngIf="isLoading" class="message-wrapper assistant">
        <div class="message loading">
          <div class="message-header">
            <span class="role">Assistant</span>
          </div>
          <div class="message-content">
            <div class="typing-indicator">
              <span></span><span></span><span></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="chat-input-area">
      <div class="input-card compact">
        <textarea
          [(ngModel)]="userInput"
          (keypress)="onKeyPress($event)"
          placeholder="Ask a follow-up question..."
          [disabled]="isLoading"
          rows="2"></textarea>
        <div class="input-card-footer">
          <span class="model-label">iMIS Intelligence</span>
          <button
            class="send-fab"
            (click)="sendMessage()"
            [disabled]="!userInput.trim() || isLoading">
            ↑
          </button>
        </div>
      </div>
    </div>

  </div>

</div>
